<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      Admin Dashboard
    </h1>
    <div class="flex flex-col gap-4 max-w-xs">
      <inertia-link
        :href="route('admin.configurations.index')"
        class="btn-indigo">
        <span>1. Kelola Konfigurasi</span>
      </inertia-link>
      <inertia-link
        :href="route('admin.portal-announcements.index')"
        class="btn-indigo">
        <span>2. Kelola Portal Pengumuman</span>
      </inertia-link>
    </div>
  </div>
</template>

<script lang="js">
import Layout from '@/Shared/Layout'
import { Link } from '@inertiajs/vue2'

export default {
  metaInfo: { title: 'Admin' },
  layout: Layout,
  components: {
    'inertia-link': Link,
  },
}
</script>
